// extracted by mini-css-extract-plugin
export default {"textarea":"n39ahUtAQO9JWUA_xDGs","dropzone":"BVUaV0CnKByKuuXIyU29","dropzoneIcon":"GTmUD0ugcZpJ7HV2e4Fn","dropzoneText":"_xnDzz1y94NRl9TQbTmM"};